export class RExpandBlock {
  constructor() {
    this.parentElements = document.querySelectorAll('[data-expand-block-parent]');

    if (!this.parentElements.length) {
      return;
    }

    this.init();
  }

  init() {
    this.parentElements.forEach((el) => {
      const target = document.querySelector(`[data-expand-block-child="${el.dataset.expandBlockParent}"]`);

      // Изначально скрываем блок
      // target.style.transition = 'opacity .25s, font-size .5s .25s, margin .5s .25s, padding .5s .25s';
      target.style.opacity = '0';
      target.style.fontSize = '0';
      target.style.margin = '0';
      target.style.padding = '0';
      // el.classList.remove('open');

      el.addEventListener('click', () => {
        if (target.style.opacity === '0') {
          // Показываем блок при клике
          target.style.transition = 'font-size .25s, margin .25s, padding .25s, opacity .5s .25s';
          target.style.opacity = '1';
          target.style.fontSize = '';
          target.style.margin = '';
          target.style.padding = '';
          el.classList.add('open');
        } else {
          // Скрываем блок при повторном клике
          target.style.transition = 'opacity .25s, font-size .5s .25s, margin .5s .25s, padding .5s .25s';
          target.style.opacity = '0';
          target.style.fontSize = '0';
          target.style.margin = '0';
          target.style.padding = '0';
          el.classList.remove('open');
        }
      });
    });
  }
}
